const placeholderQandA = [
  {
    id: 1,
    upvotes: 42,
    en: {
      question: "Who are your biggest musical influences?",
      answer:
        "I grew up listening to a lot of classic ranchera artists like Vicente Fernández and Antonio Aguilar, but I also draw a lot of inspiration from modern songwriters like Ed Maverick and Kevin Kaarl.",
    },
    es: {
      question: "¿Quiénes son tus mayores influencias musicales?",
      answer:
        "Crecí escuchando a muchos artistas clásicos de ranchera como Vicente Fernández y Antonio Aguilar, pero también me inspiro mucho en compositores modernos como Ed Maverick y Kevin Kaarl.",
    },
  },
  {
    id: 2,
    upvotes: 35,
    en: {
      question: 'What is the story behind the song "El Collar de Guamuchil"?',
      answer:
        "That song is very personal. It's about a memory from my childhood and a promise I made. I wanted to capture the feeling of nostalgia and loyalty that we often associate with our hometowns.",
    },
    es: {
      question:
        '¿Cuál es la historia detrás de la canción "El Collar de Guamuchil"?',
      answer:
        "Esa canción es muy personal. Trata de un recuerdo de mi infancia y una promesa que hice. Quería capturar el sentimiento de nostalgia y lealtad que a menudo asociamos con nuestros lugares de origen.",
    },
  },
  {
    id: 3,
    upvotes: 28,
    en: {
      question: "Are you planning a tour in the United States soon?",
      answer:
        "Absolutely! We are currently working on the logistics for a tour that will cover several cities in California, Texas, and Arizona. Stay tuned to the mailing list for announcements!",
    },
    es: {
      question: "¿Estás planeando una gira por los Estados Unidos pronto?",
      answer:
        "¡Por supuesto! Actualmente estamos trabajando en la logística para una gira que cubrirá varias ciudades en California, Texas y Arizona. ¡Estén atentos a la lista de correo para los anuncios!",
    },
  },
];

export default placeholderQandA;
